// extracted by mini-css-extract-plugin
export default {"root":"Header__root___HA2KM","content":"Header__content___pVd0_","title":"Header__title___MroLR","description":"Header__description___JVtLM"};